<template>
  <ValidationObserver v-slot="{ errors, failed }" slim>
    <div class="question" :class="{ 'is-danger': failed }">
      <div v-if="isDraggable" class="icon handle">
        <font-awesome-icon icon="grip-horizontal"></font-awesome-icon>
      </div>
      <div class="columns">
        <div v-if="!answer" class="column is-narrow is-icon">
          <slot name="icon"></slot>
        </div>

        <div class="column" :class="{ 'is-6': answer, 'is-6': !answer }">
          <slot></slot>
        </div>
        <div class="column is-3-fullhd is-4 is-right">
          <slot name="right"></slot>
        </div>
      </div>
    </div>
  </ValidationObserver>
</template>

<script>
export default {
  name: 'QuestionTemplate',
  props: {
    answer: {
      type: Boolean,
      default: false
    },
    isDraggable: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss">
.question {
  border: 1px solid $input-border-color;
  // background-color: $overlay-white;
  border-radius: $radius;
  padding: 2rem 2rem;
  width: 100%;
  // background: none;
  position: relative;
  &.is-danger {
    border-color: $danger;
  }
  &:not(:last-child) {
    margin-bottom: $block-spacing * 2;
  }

  .column {
    &.is-icon {
      width: 40px;
      box-sizing: content-box;
    }
    &.is-right {
      margin-left: auto;
    }
  }
  &.is-add-button {
    margin-top: 3rem;
    &,
    label {
      cursor: pointer;
    }
    &:hover {
      background-color: $overlay-white;
    }

    .columns {
      align-items: center;
    }
  }
  .handle {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    display: inline-block;
    margin: 0 auto;
    cursor: move;
  }
}
</style>
